/** Same access as integration config editors (e.g. SELECT_PACKAGE_E_PRODUCTS). */
export function canEditIntegrationConfigs(roles: string[] = []): boolean {
  return (
    roles.includes("SELECT_PACKAGE_E_PRODUCTS") ||
    roles.includes("limoome_shop.admin")
  );
}
